import { useState, useEffect } from 'react';
import { getCoverPic } from '../pages/Auth/authSCG';
import coverPicture from './../assets/coverPicture.jpg';

export default function useCoverPic() {
  const [coverPic, setCoverPic] = useState<string | null>(getCoverPic());
  useEffect(() => {
    async function fetchPicture() {
      try {
        const result = await fetch(
          'https://source.unsplash.com/collection/1066637/600x400/daily'
        );
        setCoverPic(result.url);
        localStorage.setItem('coverPic', result.url);
      } catch (error) {
        setCoverPic(coverPicture);
        localStorage.setItem('coverPic', coverPicture);
        if (error instanceof Error) console.error(error.message);
      }
    }
    if (!getCoverPic()) {
      fetchPicture();
    }
  }, []);
  return coverPic;
}
